export enum DeliveryPartnersConfigurationGroupEnum {
  uberEats = 'Uber Eats',
  deliveroo = 'Deliveroo',
  justEat = 'Just Eat',
  gigable = 'Gigable',
 }
